import { LANG, LANG_EN, LANGUAGE_CODE_MAP } from "@/constants/Language";
import {
  ArticleLevel,
  AssignmentMember,
  NestedAssignmentMember,
} from "@/types/models";
import {
  ILegacyStudentReadingLevel,
  IRecommendedReadingLevel,
} from "@/types/models/ReadingLevel.interface";

function getStudentReadingLevelLanguage(
  studentReadingLevel:
    | IRecommendedReadingLevel
    | ILegacyStudentReadingLevel
    | undefined,
) {
  if (!studentReadingLevel || !("language" in studentReadingLevel)) return;
  return studentReadingLevel.language;
}

function getAssignmentLanguage(
  assignmentMembers: AssignmentMember[] | NestedAssignmentMember[],
) {
  const assignmentMember = assignmentMembers[0];

  if (!assignmentMember) return;

  return !("content" in assignmentMember)
    ? assignmentMember.language
    : assignmentMember.content.language;
}

export default function getCurrentLanguage({
  assignmentMembers,
  level,
  studentReadingLevel,
}: {
  assignmentMembers: AssignmentMember[] | NestedAssignmentMember[];
  level: ArticleLevel | undefined;
  studentReadingLevel:
    | IRecommendedReadingLevel
    | ILegacyStudentReadingLevel
    | undefined;
}) {
  const assignmentLanguage = getAssignmentLanguage(assignmentMembers);
  const levelIdLanguage = level?.language;
  const studentReadingLevelLanguage =
    getStudentReadingLevelLanguage(studentReadingLevel);

  let currentLangCode: LANG = LANG_EN;

  if (assignmentLanguage) {
    currentLangCode = LANGUAGE_CODE_MAP[assignmentLanguage];
  } else if (levelIdLanguage) {
    currentLangCode = levelIdLanguage;
  } else if (studentReadingLevelLanguage) {
    currentLangCode = LANGUAGE_CODE_MAP[studentReadingLevelLanguage];
  }

  return currentLangCode;
}
